var render, staticRenderFns
import script from "./ReadController.vue?vue&type=script&lang=js&"
export * from "./ReadController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef83840",
  null
  
)

export default component.exports